export default __webpack_public_path__ + "static/backstagesupport-52-f3d7a29315e7adca4ecab68003d15295.png";